import React from 'react';
import { Form, Card, Button } from 'react-bootstrap';
import { Routes, Route, Link } from 'react-router-dom';
import { Container, Nav, Navbar } from 'react-bootstrap';

function EuroKarsRef1() {
    return (
        <>
            <header>
                <div class="header_top_nav">
                    <div class="container-lg">
                        <div class="header_top_nav_content">
                            <div class="social_media">
                                <ul>
                                    <li>
                                        <a href="#">
                                            <i class="fa-brands fa-linkedin-in"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="contect_number">
                                <i class="fi fi-rr-phone-call"></i>
                                <a href="tel:+65 6331 0600">+65 6331 0600</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="header_main">
                    <div class="container-lg">
                        <nav class="navbar navbar-expand-md">
                            <div class="navbar-wrap">
                                <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                                    <i class="fi fi-rr-menu-burger"></i>
                                </button>
                                <div class="navbar_logo">
                                    <a class="navbar-brand" href="./index.html">
                                        <img src="../assets/image/logo.svg" alt="" />
                                    </a>
                                </div>

                                <div class="collapse navbar-collapse" id="navbarText">
                                    <div class="nav_icon d-md-none d-block">
                                        <img src="../assets/image/home.svg" alt="" />
                                    </div>
                                    <ul class="navbar-nav ms-auto">
                                        <li class="nav-item dropdown navbar-brand-dropdown">
                                            <a class="nav-link dropdown-toggle" href="./financing.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Financing <i class="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./apply_loan.html">Apply Loan</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="#">Apply eGIRO</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="#">WhatsApp Us</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item dropdown navbar-brand-dropdown">
                                            <a class="nav-link dropdown-toggle" href="./insurance.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Insurance <i class="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./get_quotation.html">Get Quotation</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./renew_my_policy.html">Renew My Policy</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./the_group.html">The Group</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./news.html">Newsroom</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./contact_us.html">Contact Us</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./sign_in.html">Dealer Sign In</a>
                                        </li>
                                    </ul>
                                    <div class="button">
                                        <a href="./apply_loan.html" class="btn btn_primary">Apply Loan</a>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
            <header class="header_sticky">
                <div class="header_main">
                    <div class="container-lg">
                        <nav class="navbar navbar-expand-md">
                            <div class="navbar-wrap">
                                <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTextSticky" aria-controls="navbarTextSticky" aria-expanded="false" aria-label="Toggle navigation">
                                    <i class="fi fi-rr-menu-burger"></i>
                                </button>
                                <div class="navbar_logo">
                                    <a class="navbar-brand" href="./index.html">
                                        <img src="../assets/image/logo.svg" alt="" />
                                    </a>
                                </div>

                                <div class="collapse navbar-collapse" id="navbarTextSticky">
                                    <div class="nav_icon d-md-none d-block">
                                        <img src="../assets/image/home.svg" alt="" />
                                    </div>
                                    <ul class="navbar-nav ms-auto">
                                        <li class="nav-item dropdown navbar-brand-dropdown">
                                            <a class="nav-link dropdown-toggle" href="./financing.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Financing <i class="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./apply_loan.html">Apply Loan</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="#">Apply eGIRO</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="#">WhatsApp Us</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item dropdown navbar-brand-dropdown">
                                            <a class="nav-link dropdown-toggle" href="./insurance.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Insurance <i class="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./get_quotation.html">Get Quotation</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./renew_my_policy.html">Renew My Policy</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./the_group.html">The Group</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./news.html">Newsroom</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./contact_us.html">Contact Us</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./sign_in.html">Dealer Sign In</a>
                                        </li>
                                    </ul>
                                    <div class="button">
                                        <a href="./apply_loan.html" class="btn btn_primary">Apply Loan</a>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>

            <section class="position-relative-none">
                <div class="content content_wrap">
                    <div class="container-lg">
                        <div class="page_main_title">
                            <h1>Apply Loan</h1>
                            <p>Where Ownership Begins</p>
                        </div>
                        <div class="contact_us_main">
                            <div class="box">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="box_title_wrap">
                                            <h2>Personal Information</h2>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">NRIC</label>
                                                    <input type="text" class="form-control" placeholder="Enter NRIC number" tabindex="1" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Name</label>
                                                    <input type="text" class="form-control" placeholder="Enter name" tabindex="4" />
                                                </div>
                                                
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Gender</label>
                                                    <select class="form-select" tabindex="7">
                                                        <option hidden="">Select gender</option>
                                                        <option>Male</option>
                                                        <option>Female</option>
                                                        <option>Other</option>
                                                    </select>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Race</label>
                                                    <select class="form-select" tabindex="10">
                                                        <option hidden="">Select</option>
                                                        <option>Option 1</option>
                                                        <option>Option 2</option>
                                                        <option>Option 3</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Nationality</label>
                                                    <select class="form-select" tabindex="13">
                                                        <option hidden="">Select nationality</option>
                                                        <option>Option 1</option>
                                                        <option>Option 2</option>
                                                        <option>Option 3</option>
                                                    </select>
                                                </div>
                                                
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Date of Birth</label>
                                                    <div class="form_group_icon">
                                                        <div class="icon">
                                                            <i class="fi fi-rr-calendar"></i>
                                                        </div>
                                                        <input type="text" class="form-control date_picker flatpickr-input" placeholder="Select date of birth" tabindex="17" readonly="readonly" />
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Marital Status</label>
                                                    <select class="form-select" tabindex="19">
                                                        <option hidden="">Select marital status</option>
                                                        <option>Option 1</option>
                                                        <option>Option 2</option>
                                                        <option>Option 3</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Email</label>
                                                    <input type="email" class="form-control" placeholder="Enter email address" tabindex="2" />
                                                </div>
                                                
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Mobile No.</label>
                                                    <input type="text" class="form-control" placeholder="Enter mobile number" tabindex="5" />
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Address Line 1</label>
                                                    <input type="text" class="form-control" placeholder="Enter address" tabindex="8" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Address Line 2</label>
                                                    <input type="text" class="form-control" placeholder="Enter address" tabindex="11" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="row">
                                                    <div class="col-6">
                                                        <div class="form_main">
                                                            <label class="form-label">Country</label>
                                                            <select class="form-select" tabindex="14">
                                                                <option hidden="">Select country</option>
                                                                <option>Option 1</option>
                                                                <option>Option 2</option>
                                                                <option>Option 3</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="form_main">
                                                            <label class="form-label">Postal Code</label>
                                                            <input type="text" class="form-control" placeholder="Enter postal code" tabindex="15" />
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Residential Status</label>
                                                    <select class="form-select" tabindex="18">
                                                        <option hidden="">Select residential status</option>
                                                        <option>Option 1</option>
                                                        <option>Option 2</option>
                                                        <option>Option 3</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Type of HDB</label>
                                                    <select class="form-select" tabindex="3">
                                                        <option hidden="">Select HDB type</option>
                                                        <option>Option 1</option>
                                                        <option>Option 2</option>
                                                        <option>Option 3</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Type of Housing</label>
                                                    <select class="form-select" tabindex="6">
                                                        <option hidden="">Select housing type</option>
                                                        <option>Option 1</option>
                                                        <option>Option 2</option>
                                                        <option>Option 3</option>
                                                    </select>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Ownership of Private Residential</label>
                                                    <select class="form-select" tabindex="9">
                                                        <option hidden="">Select</option>
                                                        <option>Option 1</option>
                                                        <option>Option 2</option>
                                                        <option>Option 3</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Occupation</label>
                                                    <input type="text" class="form-control" placeholder="Enter occupation" tabindex="12" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form_main">
                                                    <label class="form-label">Employer Name</label>
                                                    <input type="text" class="form-control" placeholder="Enter employer name" tabindex="16" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">

                                                <div class="form_main pb-0">
                                                    <label class="form-label">Notice of Assessment (Last 2 Years)</label>
                                                </div>
                                                <div class="inner_box inner_box_input">
                                                    <div class="label">
                                                        <label for="">Year</label>
                                                    </div>
                                                    <div class="form_main">
                                                        <input type="text" class="form-control yearpicker" placeholder="eg. 2021" tabindex="20" /><div class="yearpicker-container hide yearpicker-dropdown">
                                                            <div class="yearpicker-header">
                                                                <div class="yearpicker-prev" data-view="yearpicker-prev">‹</div>
                                                                <div class="yearpicker-current" data-view="yearpicker-current"></div>
                                                                <div class="yearpicker-next" data-view="yearpicker-next">›</div>
                                                            </div>
                                                            <div class="yearpicker-body">
                                                                <ul class="yearpicker-year" data-view="years">
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2020</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2021</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2022</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2023</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2024</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2025</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2026</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2027</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2028</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2029</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2030</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2031</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="divider"></div>
                                                    <div class="form_main">
                                                        <input type="text" class="form-control" placeholder="Amount" tabindex="21" />
                                                    </div>
                                                </div>
                                                <div class="inner_box inner_box_input">
                                                    <div class="label">
                                                        <label for="">Year</label>
                                                    </div>
                                                    <div class="form_main">
                                                        <input type="text" class="form-control yearpicker" placeholder="eg. 2021" tabindex="22" /><div class="yearpicker-container hide yearpicker-dropdown">
                                                            <div class="yearpicker-header">
                                                                <div class="yearpicker-prev" data-view="yearpicker-prev">‹</div>
                                                                <div class="yearpicker-current" data-view="yearpicker-current"></div>
                                                                <div class="yearpicker-next" data-view="yearpicker-next">›</div>
                                                            </div>
                                                            <div class="yearpicker-body">
                                                                <ul class="yearpicker-year" data-view="years">
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2020</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2021</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2022</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2023</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2024</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2025</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2026</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2027</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2028</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2029</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2030</li>
                                                                    <li class="yearpicker-items " data-view="yearpicker-items">2031</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="divider"></div>
                                                    <div class="form_main">
                                                        <input type="text" class="form-control" placeholder="Amount" tabindex="23" />
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="box">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="box_title_wrap">
                                            <h2>About Your Vehicle</h2>
                                        </div>
                                        <div class="form-check form-switch switch-sm">
                                            <input class="form-check-input toggleSwitch" type="checkbox" role="switch" id="vehicle_type" />
                                            <label class="form-label mb-0" for="vehicle_type">Is this loan for your own vehicle?</label>
                                        </div>
                                        <div class="dealer_vehicle">
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form_main">
                                                        <label class="form-label">Reg No.</label>
                                                        <input type="text" class="form-control" placeholder="Enter Reg number" tabindex="24" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form_main">
                                                        <label class="form-label">Owner ID Type</label>
                                                        <select class="form-select" tabindex="25">
                                                            <option hidden="">Select owner ID</option>
                                                            <option>Option 1</option>
                                                            <option>Option 2</option>
                                                            <option>Option 3</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form_main">
                                                        <label class="form-label">Owner ID (Last 4 characters)</label>
                                                        <input type="text" class="form-control" placeholder="e.g 892G" tabindex="26" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="box_inner_sub_title">
                                                        <p>Fill in your Dealer Info</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form_main">
                                                        <label class="form-label">Dealer Name</label>
                                                        <input type="text" class="form-control" placeholder="Enter name" tabindex="27" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form_main">
                                                        <label class="form-label">Dealer Mobile</label>
                                                        <input type="text" class="form-control" placeholder="Enter mobile number" tabindex="28" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form_main">
                                                        <label class="form-label">Dealer Email</label>
                                                        <input type="text" class="form-control" placeholder="Enter email" tabindex="29" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form_main">
                                                        <label class="form-label">Dealer Remarks</label>
                                                        <textarea class="form-control custom_textarea_height" placeholder="Write remarks here" tabindex="30"></textarea>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form_main">
                                                        <label class="form-label">Upload Agreement</label>
                                                        <div id="myDropzone1" class="dropzone dz-clickable">
                                                            <div class="dz-default dz-message">
                                                                <button class="dz-button" type="button"><i class="fi fi-rr-cloud-upload-alt"></i>Upload NRIC/Identification or <span>Browse</span><span class="small_text">Please upload document in PDF format</span></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="own_vehicle" style={{ display: 'none' }}>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="box_inner_sub_title">
                                                        <p>Fill in your Own Vehicle Info</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form_main">
                                                        <label class="form-label">New / Used</label>
                                                        <select class="form-select" tabindex="31">
                                                            <option hidden="">Select</option>
                                                            <option>Option 1</option>
                                                            <option>Option 2</option>
                                                            <option>Option 3</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form_main">
                                                        <label class="form-label">Reg No.</label>
                                                        <input type="text" class="form-control" placeholder="Enter reg. number" tabindex="32" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form_main">
                                                        <label class="form-label">Make</label>
                                                        <input type="text" class="form-control" placeholder="Enter make" tabindex="33" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form_main">
                                                        <label class="form-label">Model</label>
                                                        <input type="text" class="form-control" placeholder="Enter model number" tabindex="34" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form_main">
                                                        <label class="form-label">Upload Agreement</label>
                                                        <div id="myDropzone2" class="dropzone dz-clickable">
                                                            <div class="dz-default dz-message">
                                                                <button class="dz-button" type="button"><i class="fi fi-rr-cloud-upload-alt"></i>Upload NRIC/Identification or <span>Browse</span><span class="small_text">Please upload document in PDF format</span></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="box">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="box_title_wrap">
                                            <h2>About Your Loan</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form_main">
                                            <label class="form-label">Loan Amount</label>
                                            <input type="text" class="form-control" placeholder="Enter loan amount" tabindex="35" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form_main">
                                            <label class="form-label">Loan Tenure (Months)</label>
                                            <input type="text" class="form-control" placeholder="Enter loan tenure" tabindex="36" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form_main">
                                            <label class="form-label">Interest Rate</label>
                                            <input type="text" class="form-control" placeholder="Enter interest rate" tabindex="37" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="box">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="box_title_wrap">
                                            <h2>Guarantor Info</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form_main">
                                            <label class="form-label">Name</label>
                                            <input type="text" class="form-control" placeholder="Enter guarantor name" tabindex="38" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form_main">
                                            <label class="form-label">Email</label>
                                            <input type="text" class="form-control" placeholder="Enter email" tabindex="39" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form_main">
                                            <label class="form-label">Mobile</label>
                                            <input type="text" class="form-control" placeholder="Enter mobile number" tabindex="40" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form_main">
                                            <label class="form-label">Relationship</label>
                                            <select class="form-select" tabindex="41">
                                                <option hidden="">Select relationship</option>
                                                <option>Option 1</option>
                                                <option>Option 2</option>
                                                <option>Option 3</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <button class="btn btn_primary btn-lg">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <footer>
                <div class="footer_top_content">
                    <div class="container-lg">
                        <div class="row">
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="footer_start_content">
                                    <div class="logo">
                                        <img src="../assets/image/logo.svg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row footer_row">
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="footer_start_content">
                                    <div class="footer_title">
                                        <p>Contact Details</p>
                                    </div>
                                    <ul class="icon_text">
                                        <li class="icon_text_inner">
                                            <div class="icon">
                                                <i class="fi fi-rr-marker"></i>
                                            </div>
                                            <div class="text">
                                                <p>11 Kung Chong Road Singapore 159147</p>
                                            </div>
                                        </li>
                                        <li class="icon_text_inner">
                                            <div class="icon">
                                                <i class="fi fi-rr-envelope"></i>
                                            </div>
                                            <div class="text">
                                                <a class="text-lowercase" href="mailto:loans@eurokars.com.sg">
                                                    loans@eurokars.com.sg
                                                </a>
                                            </div>
                                        </li>
                                        <li class="icon_text_inner">
                                            <div class="icon">
                                                <i class="fi fi-rr-phone-call"></i>
                                            </div>
                                            <div class="text">
                                                <a href="tel:+65 6363 3003">+65 6363 3003 </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="footer_link_content">
                                    <div class="footer_title">
                                        <p>Operating Hours</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <ul>
                                                <li>
                                                    <p>Monday - Thursday: 8.30am - 6.00pm</p>
                                                </li>
                                                <li>
                                                    <p>Friday: 8.30am - 5.30pm</p>
                                                </li>
                                                <li>
                                                    <p>Weekends &amp; PH: Closed</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-6">
                                <div class="footer_link_content footer_end_content">
                                    <div class="footer_title">
                                        <a href="https://www.eurokarsgroup.com/" target="_blank">Eurokars Group</a>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="text">
                                                <p>Eurokars Financial Services (EFS) is a subsidiary of Eurokars Group, dedicated to delivering premium automotive excellence through passion. Driving luxury experiences since 1985.</p>
                                                <a href="https://www.eurokarsgroup.com/" target="_blank" class="footer_link_common">Click here to find out more.</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-4 col-md-6">
                                <div class="footer_link_content footer_end_content">
                                    <div class="footer_title">
                                        <p>Legal</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="footer_link">
                                                <ul>
                                                    <li>
                                                        <a href="https://www.eurokarsgroup.com/data-protection" target="_blank">Data Protection Policy</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer_bottom_content">
                    <div class="container-lg">
                        <div class="row">
                            <div class="col-12">
                                <div class="text text-center">
                                    <p>We use cookies to ensure that we give you the best experience on our website. By using our website, you agree to our&nbsp;Privacy Policy&nbsp;&amp;&nbsp;Cookie Policy.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default EuroKarsRef1;